export default __webpack_public_path__ + "static/media/check_white.6fa64522.png";